import React from 'react';

const defaultProps = {
  type: 'text',
  name: '',
};

const Input = React.forwardRef(({ label, register, type, ...rest }, ref) => {
  return (
    <div className="input">
      <input
        type={type}
        className="input__input"
        ref={ref}
        {...rest}
        placeholder=" "
      />
      <label className="input__label">{label}</label>
    </div>
  );
});

Input.defaultProps = defaultProps;

export default Input;
